import * as types from "store/types";

export const openEnquiry = () => ({
  type: types.OPEN_ENQUIRY,
});

export const closeEnquiry = () => ({
  type: types.CLOSE_ENQUIRY,
});

export const toggleEnquiry = () => ({
  type: types.TOGGLE_ENQUIRY,
});
